domainInfo.$inject = ['graph', 'adminApi', 'userCache', 'adminEntitiesApi']

export default function domainInfo(graph, adminApi, userCache, adminEntitiesApi) {
  var domainInfo = {
    domain: null
  }

  domainInfo.setDomain = function(domain) {
    if (!this.domain || (domain && domain.uuid && this.domain.uuid != domain.uuid)) {
      this.domain = domain
      if (domain.uuid) {
        this.refreshSchools()
        this.refreshSchoolAdmins()
        this.refreshUsers()
        this.refreshSubgroups()
        this.refreshDomainInfoRecord()
        this.refreshImports()
      }
    }
  }

  // domain admins don't need to be shared so they are not here
  // school admins need to because modifying
  // domain admins should trigger refetch of school admins

  domainInfo.domainInfoRecordUI = {
    loading: false,
    domainInfoRecord: null,
    showError: false,
    errorTitle: 'Error getting domain info record',
    errorMessage: null
  }
  domainInfo.refreshDomainInfoRecord = function() {
    this.domainInfoRecordUI.loading = true
    this.domainInfoRecordUI.showError = false
    return adminEntitiesApi.getDomain(this.domain.uuid, { include: 'supergroups' }).then(
      function(response) {
        this.domainInfoRecordUI.domainInfoRecord = response.data;
        this.domainInfoRecordUI.loading = false;
      }.bind(this),
      function(response) {
        this.domainInfoRecordUI.loading = false;
        if (response.status === 404) {
          this.domainInfoRecordUI.domainInfoRecord = {
            domain_uuid: this.domain.uuid
          };
        } else {
          this.domainInfoRecordUI.showError = true;
          this.domainInfoRecordUI.errorMessage = response.data;
        }
      }.bind(this)
    );
  }

  domainInfo.saveDomainInfoRecord = function(domainInfoRecord) {
    this.domainInfoRecordUI.loading = true
    this.domainInfoRecordUI.showError = false
    graph.saveDomainInfo(domainInfoRecord).then(
      function(response) {
        this.domainInfoRecordUI.domainInfoRecord = response
        this.domainInfoRecordUI.loading = false
      }.bind(this),
      function(response) {
        this.domainInfoRecordUI.errorMessage = response
        this.domainInfoRecordUI.loading = false
        this.domainInfoRecordUI.showError = true
      }.bind(this)
    )
  }

  // domain schools/school admins
  domainInfo.schoolsUI = {
    loading: false,
    schools: [],
    schoolAdmins: {},
    showError: false,
    errorTitle: 'Error Fetching Schools',
    errorMessage: null
  }
  domainInfo.refreshSchools = function() {
    if (this.domain) {
      this.schoolsUI.loading = true
      graph.getDomainSchools(this.domain.uuid).then(
        function(schools) {
          this.schoolsUI.schools = schools
          this.schoolsUI.loading = false
        }.bind(this),
        function(reason) {
          this.schoolsUI.loading = false
        }
      )
    }
  }
  domainInfo.subgroupsUI = {
    loading: false,
    subgroups: [],
    showError: false,
    errorTitle: 'Error Fetching Subgroups',
    errorMessage: null
  }
  domainInfo.refreshSubgroups = function() {
    if (this.domain) {
      this.subgroupsUI.loading = true
      adminEntitiesApi.listSubgroups({ domain_uuid: this.domain.uuid }).then(
        function(subgroups) {
          this.subgroupsUI.subgroups = subgroups.data
          this.subgroupsUI.loading = false
        }.bind(this),
        function(reason) {
          console.error('error refreshing subgroups', reason)
          this.subgroupsUI.loading = false
          this.subgroupsUI.showError = true
          this.subgroupsUI.errorMessage = reason
        }.bind(this)
      )
    }
  }
  domainInfo.refreshSchoolAdmins = function() {
    if (this.domain) {
      graph.getDomainSchoolAdmins(this.domain.uuid).then(
        function(schoolAdminsMap) {
          this.schoolsUI.schoolAdmins = schoolAdminsMap
        }.bind(this)
      )
    }
  }

  // domain users
  domainInfo.usersUI = {
    loading: false,
    schoolUuid: '',
    subgroupUuid: '',
    users: [],
    userUuids: [],
    showError: false,
    errorTitle: 'Error Fetching Users',
    errorMessage: null
  }
  domainInfo.refreshUsers = async function(options = { cached: true }) {
    if (!this.domain || !this.domain.uuid) return
    this.usersUI.loading = true
    this.usersUI.errorMessage = null
    this.usersUI.showError = false

    var fetchFunc = graph.getDomainUserLicenses
    if (options.cached) {
      fetchFunc = userCache.fetchNormalizedUsers
    }

    try {
      var users = await fetchFunc(this.domain.uuid, this.usersUI.schoolUuid, this.usersUI.subgroupUuid)
      this.usersUI.users = users
      this.usersUI.userUuids = users.map(u => u.uuid)
      this.usersUI.loading = false

      if (!options.cached) {
        var userActivations = await this.refreshUserActivations()
        let userActivationsHash = {}
        userActivations.forEach(ua => (userActivationsHash[ua.user_uuid] = ua))
        this.usersUI.users = this.usersUI.users.map(user => {
          let userActivation = userActivationsHash[user.uuid]
          if (userActivation) {
            user.toolkit_last_active = userActivation.last_active_toolkit
            user.pathways_last_active = userActivation.last_active_pathways
            user.toolkit_report_date = userActivation.report_date_toolkit
            user.pathways_report_date = userActivation.report_date_pathways
          }
          return user
        })
      }
    } catch (err) {
      this.usersUI.loading = false
      this.usersUI.errorMessage = err.message
      this.usersUI.showError = true
    }
  }
  domainInfo.refreshUserActivations = function() {
    let today = new Date()
    let month = today.getMonth()
    let schoolYear = today.getFullYear()
    if (month < 7) {
      schoolYear -= 1
    }
    return adminApi.getDomainUserConsolidatedActivations(this.domain.uuid, schoolYear, [
      'toolkit',
      'pathways'
    ])
  }

  // domain import records
  domainInfo.importsUI = {
    imports: [],
    loading: false
  }

  domainInfo.refreshImports = async function() {
    if (!this.domain || !this.domain.uuid) return
    this.importsUI.loading = true
    var domainImports = await adminApi.getCompletedImportsForDomain(this.domain.uuid, 1000, 0)
    this.importsUI.imports = domainImports
    this.importsUI.loading = false
  }

  // domain user cache
  domainInfo.usersCacheUI = {
    opMetadata: null,
    refreshing: false,
    status: ''
  }
  const LARGE_NUM_USER_THRESHOLD = 1000
  domainInfo.refreshUserCache = async function({ userUuids }) {
    if (!this.domain || !this.domain.uuid) {
      return
    }

    let numUsers = (this.usersUI && this.usersUI.users && this.usersUI.users.length) || 0
    if (Array.isArray(userUuids) && userUuids.length > 0) {
      numUsers = userUuids.length
    }

    if (numUsers > LARGE_NUM_USER_THRESHOLD) {
      if (!confirm('This may take a few minutes - are you sure?')) return
    }

    this.usersCacheUI.refreshing = true
    this.usersCacheUI.opMetadata = await userCache.refreshDomainUsers({
      domainUuid: this.domain.uuid,
      userUuids,
      onOpStartCallback: op => {
        this.usersCacheUI.status = `Performing ${op}...`
      }
    })
    this.usersCacheUI.refreshing = false
    this.usersCacheUI.status = ''

    this.refreshUsers({ cached: true })
  }

  // deleting graph entities
  domainInfo.deleteEntity = async function(uuid) {
    return graph.deleteEntity(uuid)
  }

  domainInfo.getDomain = function(domainUuid) {
    return adminEntitiesApi.getDomain(domainUuid, { include: 'supergroups' });
  }

  return domainInfo
}